import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadIndividualConsultationScheduleItems } from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';
import { withTranslation } from 'react-i18next';
import { deleteIndividualConsultationScheduleItem } from './actions';

class IndividualConsultationsSchedule extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}
	
	reloadData() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleDelete(id) {
		const { deleteIndividualConsultationScheduleItem } = this.props;
		deleteIndividualConsultationScheduleItem(id, () => this.reloadData());
	}

	render() {
		const { isReadonly, pagination, data, t } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading}/>
				<List
					isReadonly={isReadonly}
					onFetchData={this.handleListEvent}
					onDelete={this.handleDelete}
					data={data}
					t={t}
					{...pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { individualConsultationScheduleItems },
		auth: { currentUser },
		lookups: { recurrenceDaysOfWeek }
	} = state;

	const individualConsultationSchedulePagination = pagination.individualConsultationSchedule.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: individualConsultationSchedulePagination.ids.map(id => individualConsultationScheduleItems[id]),
		pagination: individualConsultationSchedulePagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'IndividualConsultationsSchedule')
	};
};

const mapDispatchToProps = {
	loadEntities: loadIndividualConsultationScheduleItems,
	deleteIndividualConsultationScheduleItem,
	initializeFilter: (data, fields) => initialize('individualConsultationsScheduleFilter', data, fields)
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(IndividualConsultationsSchedule));